import { render, staticRenderFns } from "./Social.vue?vue&type=template&id=749b9b47&scoped=true&"
import script from "./Social.vue?vue&type=script&lang=ts&"
export * from "./Social.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749b9b47",
  null
  
)

export default component.exports